var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNflLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.327,
    height: 48.076,
    viewBox: "0 0 35.327 48.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11340",
    "data-name": "Group 11340",
    transform: "translate(-198.619 -29.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10107",
    "data-name": "Path 10107",
    d: "M217.933,31.523a12.169,12.169,0,0,1-1.65-2.484,12.174,12.174,0,0,1-1.65,2.484c-4.156,4.816-9.747,6.431-16.013.781V65.143c.068,3.729,2.9,4.99,5.519,5.972l2.048.581c3.07.4,6.05,1.158,10.1,5.419,4.046-4.26,7.027-5.022,10.1-5.419l2.048-.581c2.617-.982,5.451-2.244,5.519-5.972V32.3C227.68,37.954,222.089,36.339,217.933,31.523Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10108",
    "data-name": "Path 10108",
    d: "M230.292,51.272a11.019,11.019,0,0,1-1.548-2.314,11.015,11.015,0,0,1-1.548,2.314A10.658,10.658,0,0,1,212.531,52.7V81.671c.062,3.371,2.658,4.512,5.055,5.4l1.875.525c2.816.359,5.551,1.049,9.267,4.92l.016-.022.016.022c3.716-3.871,6.451-4.561,9.267-4.92l1.875-.525c2.4-.888,4.993-2.029,5.055-5.4V52.7A10.658,10.658,0,0,1,230.292,51.272Z",
    transform: "translate(-12.334 -17.659)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11336",
    "data-name": "Group 11336",
    transform: "translate(211.743 36.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10109",
    "data-name": "Path 10109",
    d: "M322.95,98.164s-4.988-.727-7.376,3.129a7.941,7.941,0,0,0-.694,7.266s5.009.842,7.668-3.255A7.8,7.8,0,0,0,322.95,98.164Z",
    transform: "translate(-314.31 -97.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11334",
    "data-name": "Group 11334",
    transform: "translate(1.947 1.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10110",
    "data-name": "Path 10110",
    d: "M343.288,122.247l2.234,1.143q.128-.135.257-.268l-2.238-1.145Q343.413,122.109,343.288,122.247Z",
    transform: "translate(-341.948 -120.35)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10111",
    "data-name": "Path 10111",
    d: "M336.65,130.249l2.176,1.113c.084-.105.171-.209.259-.312l-2.2-1.126Q336.763,130.082,336.65,130.249Z",
    transform: "translate(-336.063 -127.394)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10112",
    "data-name": "Path 10112",
    d: "M331.477,139.13l2.1,1.074q.091-.156.186-.3l-2.117-1.083Q331.559,138.972,331.477,139.13Z",
    transform: "translate(-331.477 -135.279)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10113",
    "data-name": "Path 10113",
    d: "M360.255,107.631c-.109.073-.22.15-.331.23l2.157,1.1q.151-.128.3-.248Z",
    transform: "translate(-356.697 -107.631)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10114",
    "data-name": "Path 10114",
    d: "M350.907,114.675l2.229,1.14q.153-.144.305-.282l-2.214-1.132C351.12,114.488,351.014,114.58,350.907,114.675Z",
    transform: "translate(-348.703 -113.632)",
    fill: "#092a55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11335",
    "data-name": "Group 11335",
    transform: "translate(0.397 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10115",
    "data-name": "Path 10115",
    d: "M368.409,98.989a29.008,29.008,0,0,1,2.314-1.831l-.19-.128a9.8,9.8,0,0,0-2.674,1.674Z",
    transform: "translate(-362.181 -97.03)",
    fill: "#092a55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10116",
    "data-name": "Path 10116",
    d: "M320.317,143.858a28.722,28.722,0,0,0-2.508,5.316l.227.138a34.842,34.842,0,0,1,2.733-5.228Z",
    transform: "translate(-317.809 -138.546)",
    fill: "#092a55"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11339",
    "data-name": "Group 11339",
    transform: "translate(201.514 38.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11337",
    "data-name": "Group 11337",
    transform: "translate(19.943 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10117",
    "data-name": "Path 10117",
    d: "M450.008,113.506l.539,1.535h1.7l-1.358,1.083.518,1.655-1.4-1.07-1.4,1.005.539-1.6-1.314-1.071h1.638Z",
    transform: "translate(-442.4 -113.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10118",
    "data-name": "Path 10118",
    d: "M450.008,157.747l.539,1.536h1.7l-1.358,1.081.518,1.655-1.4-1.071-1.4,1.006.539-1.6-1.314-1.071h1.638Z",
    transform: "translate(-442.4 -152.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10119",
    "data-name": "Path 10119",
    d: "M402.5,157.747l.539,1.536h1.7l-1.357,1.081.518,1.655-1.4-1.071-1.4,1.006.538-1.6-1.314-1.071h1.638Z",
    transform: "translate(-400.283 -152.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M402.123,113.506l.539,1.535h1.7l-1.358,1.083.517,1.655-1.4-1.07-1.4,1.005.539-1.6-1.315-1.071h1.638Z",
    transform: "translate(-399.946 -113.506)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10121",
    "data-name": "Path 10121",
    d: "M274.2,113.506l.539,1.535h1.7l-1.358,1.083.518,1.655-1.4-1.07-1.4,1.005.538-1.6-1.314-1.071h1.638Z",
    transform: "translate(-266.592 -113.506)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10122",
    "data-name": "Path 10122",
    d: "M274.2,157.747l.539,1.536h1.7l-1.358,1.081.518,1.655-1.4-1.071-1.4,1.006.538-1.6-1.314-1.071h1.638Z",
    transform: "translate(-266.592 -152.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10123",
    "data-name": "Path 10123",
    d: "M226.694,157.747l.539,1.536h1.7l-1.357,1.081.518,1.655-1.4-1.071-1.4,1.006.538-1.6-1.314-1.071h1.638Z",
    transform: "translate(-224.475 -152.728)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10124",
    "data-name": "Path 10124",
    d: "M226.315,113.506l.539,1.535h1.7l-1.358,1.083.517,1.655-1.4-1.07-1.4,1.005.538-1.6-1.315-1.071h1.638Z",
    transform: "translate(-224.139 -113.506)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10125",
    "data-name": "Path 10125",
    d: "M226.686,205.289V219.2c.056,3.1,2.395,4.144,4.554,4.96l1.689.482c2.538.33,5,.964,8.349,4.519l.015-.02.015.02c3.348-3.555,5.812-4.189,8.349-4.519l1.69-.482c2.16-.816,4.5-1.863,4.554-4.96V205.289Z",
    transform: "translate(-24.883 -156.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10126",
    "data-name": "Path 10126",
    d: "M334.657,221.526h-3.506v2.2h.924v12.751c-.568-.065-1.055-.1-1.055-.1v1.994a13.965,13.965,0,0,1,2.092.392c.7.211,2.419,1.013,2.419,1.013v-2.207a6.951,6.951,0,0,0-.874-.447v-7.134h1.351l.324.909h1.451v-4.087h-1.451l-.347.974h-1.328V223.73h1.7l.556,1.294h1.749v-3.5Z",
    transform: "translate(-117.382 -170.652)",
    fill: "#a40c1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10127",
    "data-name": "Path 10127",
    d: "M247.419,220.5h-3.335v2.2h.752v5.385l-2.7-7.714v-.006h-3.319v2.2h.736v9.7c-.593-.031-1.11-.032-1.11-.032l.179,2.243a12.528,12.528,0,0,1,2.121.274c.717.182,2.5.947,2.5.947l-.2-2.482a6.7,6.7,0,0,0-.912-.433V228.2l2.794,7.989,2.486.768V222.708h.719v-2.2Z",
    transform: "translate(-35.309 -169.63)",
    fill: "#a40c1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10128",
    "data-name": "Path 10128",
    d: "M408.3,230.653v3.134c-.681.152-1.421.329-2.038.5V223.733l.752-.344v-1.863h-4.087v1.863l.752.344V235.32c-.439.227-.813.449-1.112.638v2.519a43.21,43.21,0,0,1,3.836-2.021,15.716,15.716,0,0,1,3.936-.943v-4.86Z",
    transform: "translate(-180.816 -170.652)",
    fill: "#a40c1a"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNflLogo);
export default __webpack_public_path__ + "static/media/NFL-logo.8d4496039497bc74e32160829f9f8d9c.svg";
export { ForwardRef as ReactComponent };